import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-16-permutation",
  "use": "icon-icon-16-permutation-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon-16-permutation\"><g fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"M13 9a1 1 0 0 1 .117 1.993L13 11l-7.761-.001.83 1.66a1 1 0 1 1-1.789.894l-1.552-3.106A1 1 0 0 1 3.623 9H13zm-1.255-6.553 1.553 3.106A1 1 0 0 1 12.404 7H3a1 1 0 0 1 0-2l7.785-.001-.828-1.657a1 1 0 0 1 1.788-.895z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol